import { render, staticRenderFns } from "./RecomCustomer.vue?vue&type=template&id=2ffcb5e5"
import script from "./RecomCustomer.vue?vue&type=script&lang=js"
export * from "./RecomCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports